<template>
  <div ref="tabPage" role="tabpanel" :id="tabIdentifier" :data-tab-id="tabid" :class="['tab-pane', 'tab-page', { 'active': active }]">
    <div class="panel-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: { 
    tabid: String,
    first: Boolean
  },
  inject: {
    tabbedBox: {
      default() {
        return { }
      }
    }
  },
  computed: {
    tabIdentifier() {
      return this.$data.tabBoxId + '-' + this.$props.tabid
    }
  },
  data() {
    return {
      tabBoxId: 0,
      active: false
    }
  },
  mounted() {
    this.registerTabPageItem()

    var tabBox = this.findComponentParent(this.$parent, 'TabbedBox')
    if(tabBox)
      this.tabBoxId = tabBox.uuid

    this.$data.active = this.$props.first
  },
  beforeDestroy() {
  },
  destroyed() {
    this.unregisterTabPageItem()
  },
  methods: {
    registerTabPageItem() {
      this.tabbedBox.registerTabPageItem && this.tabbedBox.registerTabPageItem(this)
    },
    unregisterTabPageItem() {
      this.tabbedBox.unregisterTabPageItem && this.tabbedBox.unregisterTabPageItem(this)
    },
  }
}
</script>